import { callFunction } from "./functions-client";

// Communities platform (LOS Phase 5).
export interface Community {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  member_count: number;
  joined?: boolean;
}

export interface CommunityPost {
  id: string;
  body: string;
  created_at: string;
  author_id: string;
  author_name: string | null;
  comment_count: number;
}

export interface CommunityComment {
  id: string;
  body: string;
  created_at: string;
  author_id: string;
  author_name: string | null;
}

export const listCommunities = () =>
  callFunction<{ communities: Community[] }>("communities/list", { method: "GET" });

export const getCommunity = (slug: string) =>
  callFunction<{ community: Community; joined: boolean; role: string | null; posts: CommunityPost[] }>(
    `communities/get?slug=${encodeURIComponent(slug)}`,
    { method: "GET" },
  );

export const joinCommunity = (community_id: string) =>
  callFunction<{ ok: boolean; joined: boolean }>("communities/join", { body: { community_id } });

export const leaveCommunity = (community_id: string) =>
  callFunction<{ ok: boolean; joined: boolean }>("communities/leave", { body: { community_id } });

export const postToCommunity = (community_id: string, body: string) =>
  callFunction<{ post: CommunityPost }>("communities/post", { body: { community_id, body } });

export const commentOnPost = (post_id: string, body: string) =>
  callFunction<{ comment: CommunityComment }>("communities/comment", { body: { post_id, body } });

export const listComments = (post_id: string) =>
  callFunction<{ comments: CommunityComment[] }>(`communities/comments?post_id=${encodeURIComponent(post_id)}`, { method: "GET" });
